import constants from "../../constants";
import utils from "../../services/utils";
import vbIncomingDocUserViewService from "../../services/vbIncomingDocUserViewService";
import vbAttachmentTokenMixin from "../../mixins/vbAttachmentTokenMixin";
import dateUtils from "../../dateUtils";
import h from "../../services/h";
import vbDocUserService from "../../services/vbDocUserService";

export default {
  mixins: [vbAttachmentTokenMixin],

  data() {
    return {
      sortList: [],
      dateQuickFilterOption: utils.getDefaultDateQuickFilterOption(),
      perfectScrollbarSetting: {
        maxScrollbarLength: 350
      },
      sendTimeRange: null,
      fromSendTime: null,
      toSendTime: null,
      isOpenAdvanceSearchDialog: false,
      isEnableAdvanceSearchDialog: false,
      incomingDocs: [],
      incomingDocsTltvb: [],
      selectedDocId: null,
      page: 0,
      size: 10,
      advanceSearchForm: {},
      sort: null,
      order: null,
      keyword: null,
      filterStatus: null,
      docReadStatusFilter: null,
      isStar: false,
      duyetCXLFilter: 0
    };
  },

  computed: {
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },
    filterStatusQuery() {
      return this.$route.query.filterStatus;
    }
  },

  watch: {
    isOpenAdvanceSearchDialog(newValue) {
      newValue && (this.isEnableAdvanceSearchDialog = newValue);
    },
    filterStatusQuery(newValue) {
      if (
        (newValue || constants.VBDEN_CHOXULY_PAGE.FILTER.ALL) !==
        (this.filterStatus || constants.VBDEN_CHOXULY_PAGE.FILTER.ALL)
      ) {
        this.advanceSearchForm.filterStatus = this.filterStatus = newValue;
        this.doSearch();
      }
    }
  },

  created() {
    // Khi click mở văn bản đi từ thông báo, default mở tab Tất cả trong phần (VB sơ duyệt, VB thông thường, Tất cả)
    if (('id' in this.$route.params) && this.$route.params.id) {
      this.duyetCXLFilter = 0;
    }
  },

  methods: {
    // filterBySendTime(event) {
    //   this.advanceSearchForm.fromSendTime =
    //     this.sendTimeRange && this.sendTimeRange[0]
    //       ? this.sendTimeRange[0].getTime()
    //       : undefined;
    //   this.advanceSearchForm.toSendTime =
    //     this.sendTimeRange && this.sendTimeRange[1]
    //       ? this.sendTimeRange[1].getTime()
    //       : undefined;
    //   this.doSearch();
    // },

    setDefaultDocDateRange() {
      const startDate = new Date(new Date().getFullYear(), 0, 1);
      this.fromSendTime = startDate;
    },

    filterBySendTime(event) {
      const a = this.isValidDate(this.fromSendTime);
      const b = this.isValidDate(this.toSendTime);

      if ((this.fromSendTime === null || !a) && (this.toSendTime === null || b)) {
        this.fromSendTime = new Date(new Date().getFullYear(), 0, 1);
      } else if ((this.toSendTime === null || !b) && (this.fromSendTime === null || a)) {
        this.toSendTime = new Date(new Date().getFullYear(), 11, 31);
      } else if (this.fromSendTime > this.toSendTime) {
        this.fromSendTime = new Date(new Date().getFullYear(), 0, 1);
        this.toSendTime = new Date(new Date().getFullYear(), 11, 31);
      }

      this.advanceSearchForm.fromSendTime = this.fromSendTime ? this.fromSendTime.getTime() : undefined;
      this.advanceSearchForm.toSendTime = this.toSendTime ? this.toSendTime.getTime() : undefined;
      this.doSearch();
    },

    isValidDate(date) {
      return date instanceof Date && !isNaN(date);
    },

    filterBySoDuyet(){
      this.advanceSearchForm.duyetCXLFilter = this.duyetCXLFilter;
      this.doSearch();
    },

    isStarChange() {
      this.$refs.starCheckbox.click();
      const isStar = this.$refs.starCheckbox.checked ? 1 : 0;
      this.advanceSearchForm.isStar = isStar;
      this.doSearch();
    },

    initSendTimeRange() {
      if (
        this.advanceSearchForm.fromSendTime ||
        this.advanceSearchForm.toSendTime
      ) {
        this.sendTimeRange = [
          dateUtils.toMoment(this.advanceSearchForm.fromSendTime),
          dateUtils.toMoment(this.advanceSearchForm.toSendTime)
        ];
      } else {
        this.sendTimeRange = dateUtils.getDatesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.LAST_YEAR
        );
        let defaultTimeRange = dateUtils.getTimesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.LAST_YEAR
        );
        this.advanceSearchForm.fromSendTime = defaultTimeRange[0];
        this.advanceSearchForm.toSendTime = defaultTimeRange[1];
      }
    },

    textBold(event) {
      if (event.hasOwnProperty("isSeen")) {
        if (event.isSeen == 1) return "";
        else return "text-bold";
      } else return "";
    },

    closeDialog() {
      this.isOpenDialogCreate = false;
    },

    isShowPriority(id) {
      return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1;
    },

    createDocSuccess() {
      this.isOpenDialogCreate = false;
      this.doSearch();
    },

    filterByStatus(event) {
      this.advanceSearchForm.filterStatus = this.filterStatus =
        event.filterStatus;
      this.doSearch();
    },

    initQuery() {
      this.advanceSearchForm = {
        filterStatus:
          this.$route.query.filterStatus ||
          constants.VBDEN_CHOXULY_PAGE.FILTER.ALL,
        fromDocDate: this.$route.query.fromDocDate
          ? parseInt(this.$route.query.fromDocDate)
          : undefined,
        toDocDate: this.$route.query.toDocDate
          ? parseInt(this.$route.query.toDocDate)
          : undefined,

        keyword: this.$route.query.keyword || undefined,

        docCode: this.$route.query.docCode || undefined,
        fileContent: this.$route.query.fileContent || undefined,
        outsidePublisherName:
          this.$route.query.outsidePublisherName || undefined,
        insidePublisherName:
          this.$route.query.insidePublisherName || undefined,
        docTypeId: this.$route.query.docTypeId || undefined,
        quote: this.$route.query.quote || undefined,
        publisherId: this.$route.query.publisherId || undefined,
        receiveDeptId: this.$route.query.receiveDeptId || undefined,
        bookId: this.$route.query.bookId || undefined,
        toIncomingDate: this.$route.query.toIncomingDate
          ? parseInt(this.$route.query.toIncomingDate)
          : undefined,
        fromIncomingDate: this.$route.query.fromIncomingDate
          ? parseInt(this.$route.query.fromIncomingDate)
          : undefined,
        toSendTime: this.$route.query.toSendTime
          ? parseInt(this.$route.query.toSendTime)
          : undefined,
        fromSendTime: this.$route.query.fromSendTime
          ? parseInt(this.$route.query.fromSendTime)
          : undefined,
        isRead: this.$route.query.isRead
          ? parseInt(this.$route.query.isRead)
          : undefined,
        isStar: this.$route.query.isStar === "1"
          ? 1
          : 0
      };

      this.docReadStatusFilter = h.find(
        this.docReadStatusFilters,
        item => item.id === (this.advanceSearchForm.isRead === undefined ? null : this.advanceSearchForm.isRead)
      );
      this.keyword = this.advanceSearchForm.keyword;
      this.filterStatus = this.advanceSearchForm.filterStatus;
      this.isStar = !!+this.$route.query.isStar;
    },

    buildQuery() {
      return utils.merge(
        {sort: this.sort || "updateTime", order: this.order || "desc"},
        this.advanceSearchForm
      );
    },

    simpleSearch(keyword) {
      this.keyword = this.advanceSearchForm.keyword = keyword;
      this.advanceSearchForm.docCode = undefined;
      this.advanceSearchForm.fileContent = undefined;
      this.advanceSearchForm.outsidePublisherName = undefined;
      this.advanceSearchForm.insidePublisherName = undefined;
      this.advanceSearchForm.docTypeId = undefined;
      this.advanceSearchForm.quote = undefined;
      this.advanceSearchForm.publisherId = undefined;
      this.advanceSearchForm.receiveDeptId = undefined;
      this.advanceSearchForm.toIncomingDate = undefined;
      this.advanceSearchForm.fromIncomingDate = undefined;
      // this.advanceSearchForm.toSendTime = undefined;
      // this.advanceSearchForm.fromSendTime = undefined;
      this.advanceSearchForm.bookId = undefined;
      this.advanceSearchForm.isStar = 0;
      this.doSearch();
    },
    //search trong vb đến/ chờ xử lý - đã xử lý
    advanceSearch_(event) {
      let advanceSearchForm = event.advanceSearchForm;
      this.sortList = event.sortList;
      // console.log(JSON.stringify(advanceSearchForm));
      this.advanceSearchForm.keyword = undefined;
      this.keyword = null;
      this.advanceSearchForm.fromDocDate =
        advanceSearchForm.fromDocDate || undefined;
      this.advanceSearchForm.toDocDate =
        advanceSearchForm.toDocDate || undefined;
      this.advanceSearchForm.docCode = advanceSearchForm.docCode || undefined;
      this.advanceSearchForm.fileContent =
        advanceSearchForm.fileContent || undefined;
      this.advanceSearchForm.outsidePublisherName =
        advanceSearchForm.outsidePublisherName || undefined;
      this.advanceSearchForm.insidePublisherName =
        advanceSearchForm.insidePublisherName || undefined;
      this.advanceSearchForm.docTypeId =
        advanceSearchForm.docTypeId || undefined;
      this.advanceSearchForm.bookId = advanceSearchForm.bookId || undefined;
      this.advanceSearchForm.quote = advanceSearchForm.quote || undefined;
      this.advanceSearchForm.publisherId =
        advanceSearchForm.publisherId || undefined;
      this.advanceSearchForm.priorityId =
        advanceSearchForm.priorityId || undefined;
      this.advanceSearchForm.receiveDeptId =
        advanceSearchForm.receiveDeptId || undefined;
      this.advanceSearchForm.toIncomingDate =
        advanceSearchForm.toIncomingDate || undefined;
      this.advanceSearchForm.fromIncomingDate =
        advanceSearchForm.fromIncomingDate || undefined;
      this.advanceSearchForm.toSendTime =
        advanceSearchForm.toSendTime || undefined;
      this.advanceSearchForm.fromSendTime =
        advanceSearchForm.fromSendTime || undefined;
      this.advanceSearchForm.sortList =
        event.sortList || undefined;
      this.advanceSearchForm.isStar = this.isStar ? 1 : 0;
      this.advanceSearchForm.docToLeader = advanceSearchForm.docToLeader;
    },

    doSort(sort) {
      this.sort = sort;
      this.order =
        sort === this.sort ? (this.order === "asc" ? "desc" : "asc") : "asc";
      this.doSearch();
    },

    doSearch() {
      this.$router.replace({
        name: this.$router.name,
        params: this.$route.params,
        query: this.buildQuery()
      });
      this.incomingDocs = [];
      this.incomingDocsTltvb = [];
      this.page = 0;
      this.$nextTick(
        () =>
          this.$refs.infiniteLoading &&
          this.$refs.infiniteLoading.stateChanger.reset()
      );
    },

    infiniteHandler($state) {
      this.list().then(items => {
        this.page += 1;
        items && items.length ? $state.loaded() : $state.complete();
      });
    },

    async list() {
      let processType;
      let pageable;
      if (this.sortList && this.sortList.length > 0) {

        let sort = [];
        h.each(this.sortList, (item) => {
          sort.push(item);
        })
        pageable = {
          page: this.page,
          size: this.size,
          sort: sort
        };
      } else {
        pageable = {
          page: this.page,
          size: this.size,
          sort: [this.sort, this.order].join(",")
        };
      }

      switch (this.filterStatus) {
        case constants.VBDEN_CHOXULY_PAGE.FILTER.CHU_TRI:
          processType = constants.PROCESS_TYPE.CHUTRI;
          break;
        case constants.VBDEN_CHOXULY_PAGE.FILTER.PHOI_HOP:
          processType = constants.PROCESS_TYPE.PHOIHOP;
          break;
        case constants.VBDEN_CHOXULY_PAGE.FILTER.NHAN_DE_BIET:
          processType = constants.PROCESS_TYPE.NHANDEBIET;
          break;
        default:
          processType = null;
          break;
      }

      let advanceSearchForm = utils.merge(this.advanceSearchForm, {
        status: this.status,
        relationType: this.relationType,
        processType: processType,
        includeBcc: true
      });

      let items = [];

      await vbIncomingDocUserViewService
        .findAllV2(advanceSearchForm, pageable)
        .then(response => {
          items = response.data;
          for (let i = 0; i < items.length; i++) {
            if (this.$route.params.id && items[i].docId === this.$route.params.id) {
              items[i].isSeen = 1;
            }
          }
        });
      await vbDocUserService.getAllVbIsStarByUserDeptRole(this.userDeptRoleId)
        .then(response => {
          const vbDocIdsIsStarMap = response.data;

          for(let i = 0; i < items.length; i++) {
            items[i].isStar = 0;
            for(let key in vbDocIdsIsStarMap) {
              if (key === items[i].docId) {
                items[i].isStar = vbDocIdsIsStarMap[key]
              }
            }
          }

          this.incomingDocs.push(...items);

          for(let i = 0; i < items.length; i++) {
            if(items[i].tltvbAgencyId !== null){
              this.incomingDocsTltvb.push(items[i])
            }
          }

        })
      return items;
    },

    exportSearchResult(fileType,name) {
      let processType;
      let pageable;
      if (this.sortList && this.sortList.length > 0) {

        let sort = [];
        h.each(this.sortList, (item) => {
          sort.push(item);
        })
        pageable = {
          page: 0,
          size: 1000,
          sort: sort
        };
      } else {
        pageable = {
          page: 0,
          size: 1000,
          sort: [this.sort, this.order].join(",")
        };
      }

      switch (this.filterStatus) {
        case constants.VBDEN_CHOXULY_PAGE.FILTER.CHU_TRI:
          processType = constants.PROCESS_TYPE.CHUTRI;
          break;
        case constants.VBDEN_CHOXULY_PAGE.FILTER.PHOI_HOP:
          processType = constants.PROCESS_TYPE.PHOIHOP;
          break;
        case constants.VBDEN_CHOXULY_PAGE.FILTER.NHAN_DE_BIET:
          processType = constants.PROCESS_TYPE.NHANDEBIET;
          break;
        default:
          processType = null;
          break;
      }
      let advanceSearchForm = utils.merge(this.advanceSearchForm, {
        status: this.status,
        relationType: this.relationType,
        processType: processType,
        includeBcc: true
      });
      let params = utils.merge(advanceSearchForm, pageable);
      params.userId=this.$store.getters.userDeptRole.userId;
      params.deptId=this.$store.getters.userDeptRole.deptId;
      params.roleId=this.$store.getters.userDeptRole.roleId;
      params.positionId = this.$store.getters.userDeptRole.positionId;
      params.fileType = fileType
      params.name = name

      let baseServiceURL = constants.BASE_SERVICE_URL;
      let reportUrl = constants.IN_PHIEU.SEARCH_RESULT_VB_DEN_CHO_XU_LY;
      window.open(
        `${baseServiceURL}${reportUrl}?${utils.serialize(params)}`
      );
    },
    getPiorityClass(id) {
      return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1
        ? "lv1"
        : "lv4";
    },

    isShowPiority(id) {
      return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1;
    },

    changeStar(item) {
      const isStar = item.isStar === 1 ? 0 : 1

      vbDocUserService.setStar({
        vbDocId: item.id,
        userDeptRoleId: this.userDeptRoleId,
        isStar: isStar
      })
        .then(() => {
          item.isStar = isStar;

          // Nếu đang filter theo văn bản có dấu sao thì sẽ reload trang nếu có thay đổi dấu sao của 1 văn bản
          if(this.isStar) {
            this.doSearch();
          }
        })
        .catch(() => {
          console.log('Không thể đánh dấu sao cho văn bản!')
        })
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/doc-in/vbDenMixin.js